module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vip-header",
    class: {
      'is-app': _vm.jsBridge.isApp
    }
  }, [_c('div', {
    staticClass: "vip-header__ctn vip-mobile-header"
  }, [(_vm.jsBridge.isApp) ? _c('button', {
    staticClass: "nav",
    on: {
      "click": _vm.onBack
    }
  }, [_c('i', {
    staticClass: "jin-icon jin-icon_nav-back"
  })]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.headerTitle))]), _vm._v(" "), (_vm.jsBridge.isApp) ? _c('button', {
    staticClass: "share",
    on: {
      "click": _vm.onShare
    }
  }, [_c('i', {
    staticClass: "jin-icon jin-icon_share"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "vip-pc-header "
  }, [_c('div', {
    staticClass: "vip-header__ctn"
  }, [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.headerTitle))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.jin10.com"
    }
  }, [_c('img', {
    staticClass: "vip-pc-header-logo",
    attrs: {
      "src": "//tv.jin10.com/assets/img/vip/logo.png",
      "srcset": "//tv.jin10.com/assets/img/vip/logo@2x.png 2x"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85de46a0","hasScoped":true,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tv/modules/VipHeader.vue
// module id = xe0A
// module chunks = 2 3 4 6 7 8 9